import { module } from 'angular';
import App from '../../../app';

class SCR0707Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, utilService, codeService, gridService, popupService, data){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		this.codes = codeService.commonCodes;
		this.msglayoutbsDtoMap = {};
		this.allMsgType = data.codes.MSG_TYPE;
		
		if(this.data.sendSysCd && (this.data.sendSysCd === 'COB' || this.data.sendSysCd === 'FDS')) {
			this.encodingColumnVisible = true;
			this.encodingData = data.intrfcMsgFieldEncodingDto && data.intrfcMsgFieldEncodingDto.filter(v=>v.srCd === 'SEND');
		}else if(this.data.receiveSysCd && (this.data.receiveSysCd === 'COB' || this.data.receiveSysCd === 'FDS')) {
			this.encodingColumnVisible = true;
			this.encodingData = data.intrfcMsgFieldEncodingDto && data.intrfcMsgFieldEncodingDto.filter(v=>v.srCd === 'RECEIVE');
		}
		
		this.initWindow('100%', '100%');
		this.initText();
		
		this.$timeout(() => {
			this.initGridOption();
			this.getMsgDetailGridData();
		});
		
		$(window).on('resize.0707', this.resizeGrid.bind(this));
		
		this.$scope.$on('$destroy', () => {
			$(window).off('resize.0707');
		});	
	}
	
	initWindow(width, height){
		this.width = width;
		this.height = height;
		this.top = 100;
		this.left = 20;
		this.right = 20;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMsg'));	
	}
	
	initGridOption(){
		this.detailGridView = new RealGridJS.TreeView('msg-detail-grid');
		this.detailDataProvider = new RealGridJS.LocalTreeDataProvider();
		this.detailGridView.setDataSource(this.detailDataProvider);		
		this.gridService.setDefaultSetting(this.detailGridView);
		this.detailGridView.setCheckBar({visible: false});
		this.detailGridView.setTreeOptions({lineVisible: false, expandImage: './assets/images/grid/expand.png', collapseImage: './assets/images/grid/collapse.png'});
		this.detailGridView.setSelectOptions({style: 'block'});
		this.detailGridView.setEditOptions({editable: true});
		this.detailGridView.setDisplayOptions({vscrollBar: true, focusVisible: true, eachRowResizable: true, focusColor: '#aaa'}); 
		this.detailGridView.setFixedOptions({colCount: 9});
		this.detailGridView.setSortingOptions({enabled: false});
		
		this.detailDataProvider.setFields([
            {fieldName: "msgSeq", dataType: 'number'}, 
            {fieldName: "fldEngNm"}, 
    		{fieldName: "fldKorNm"}, {fieldName: "cfgDesc"}, {fieldName: "dataTypeNm"}, 
    		{fieldName: "msgLen", dataType: 'number'}, {fieldName: "decimalLen", dataType: 'number'}, {fieldName: "fldLvNo", dataType: 'number'}, 
            {fieldName: "childDtoNm"}, {fieldName: "arraySizeRefVal"}, {fieldName: "indsYn"}, 
            {fieldName: "basicVal"}, {fieldName: "privacyDscd"}, {fieldName: "replKey"}, 
            {fieldName: "encYn"}, {fieldName: "alignNm"}, {fieldName: "cdAttrNm"}, 
            {fieldName: "ioKey"}, {fieldName: "korInclYn"},  {fieldName: "fldRmk"},  
            {fieldName: "confirmMeta"}, 
            {fieldName: "extrnlMsgNoYn"}, {fieldName: "iso8583SpecNo"},  
            {fieldName: "iso8583FldCharSetCd"}, {fieldName: "iso8583VariableYn"},  
            {fieldName: "iso8583FldLenTypeCd"}, {fieldName: "iso8583LenFldLen"}, 
            {fieldName: "iso8583LenFldInclYn"}, {fieldName: "iso8583LenFldCopyYn"}, 
            {fieldName: "iso8583TrnsmsnDataLen"}, {fieldName: "extrnlSrchKeyYn"}, 
            {fieldName: "fldUnqId"}, {fieldName: "parentFldNm"},
            {
            	fieldName: "ioKeyTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('IO_KEY', values[fieldNames.indexOf('ioKey')]);
            	}
    		},
    		{
            	fieldName: "msgDscdTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.codeService.getCodeValNm('MSG_TYPE', values[fieldNames.indexOf('msgDscd')]);
            	}
    		},
    		{fieldName: "iso8583FldMaxLen"}, {fieldName: "msgLayoutId"},{fieldName: "msgDscd"}, {fieldName: "fillerVal"},  
    		{fieldName: "fldEncoding"}, {fieldName: "wideHalfCharCngCd"},
    		{fieldName: "formatType"}, {fieldName: "format"}
        ]);
		
		this.detailGridView.setColumns(this._getDefaultMsgDetailGridColumns());
		
		this.detailGridView.onDataCellClicked = (grid, cell) => {
			let row = grid.getValues(cell.itemIndex);
			
			if(row.msgDscd && row.msgLayoutId) {
				
				this.selectedMsg = this.msglayoutbsDtoMap[row.msgDscd + ':' + row.msgLayoutId];
				this._selectedMsg = this.msglayoutbsDtoMap[row.msgDscd + ':' + row.msgLayoutId];
				
				this.changeTransactionType();
				this.setApplicationCodeString();
				this.setRegDttm();
				
				this.$scope.$apply();
			}
		};	
		
		this.detailGridView.onShowEditor = (grid, index) => {
			let row = grid.getValues(index.itemIndex); 
			
			if(!row.fldEngNm) {
				return false;
			}
		}
		
		this.detailGridView.onShowTooltip = (grid, index, value) => {
			let tooltip = '<div class="rg-tooltip">' + value + '</div>';
			
			if(value.length > 50) {
				 tooltip = '<div class="rg-tooltip" style="width: 500px;">' + value + '</div>';
			}
			
			return tooltip;
		};
		
		this.detailGridView.onShowHeaderTooltip = (grid, index, value) => {
			let tooltip = '<div class="rg-tooltip">' + value + '</div>';
			
			if(value.length > 50) {
				 tooltip = '<div class="rg-tooltip" style="width: 500px;">' + value + '</div>';
			}
			
			return tooltip;
		};
	}
	
	_getDefaultMsgDetailGridColumns(){
		let columns = [
			{ 
				name: "msgDscdTxt", fieldName: "msgDscdTxt", header : { text: this.text.msgType, showTooltip: false } , 
				width: 100, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "msgSeq", fieldName: "msgSeq", header : { text: this.text.msgSeq, showTooltip: false } , 
				width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "fldEngNm", fieldName: "fldEngNm", header : { text: this.text.fldEngNm, showTooltip: false }, 
				width: 138, styles: { textWrap: 'ellipse' },
				dynamicStyles: [				
					{ criteria: 'values["fldLvNo"] = 1', styles: {paddingLeft: '10px'} },
					{ criteria: 'values["fldLvNo"] = 2', styles: {paddingLeft: '20px'} },
					{ criteria: 'values["fldLvNo"] = 3', styles: {paddingLeft: '30px'} },
					{ criteria: 'values["fldLvNo"] = 4', styles: {paddingLeft: '40px'} },
					{ criteria: 'values["fldLvNo"] = 5', styles: {paddingLeft: '50px'} },
					{ criteria: 'values["fldLvNo"] = 6', styles: {paddingLeft: '60px'} }
				],
				editable: false
			},
			{
				name: "fldKorNm", fieldName: "fldKorNm", header : { text: this.text.fldKorNm, showTooltip: false }, 
				width: 138, styles: { textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "cfgDesc", fieldName: "cfgDesc", header : { text: this.text.cfgDesc, showTooltip: false }, 
				width: 100, styles: { textWrap: 'ellipse' },
				editable: false
			},
			this.gridService.getSelectionEditorColumn({ 
				name: "dataTypeNm", fieldName: "dataTypeNm", header : { text: this.text.dataType, showTooltip: false }, 
				width: 80, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.DATA_TYPE),
			{ 
				name: "msgLen", fieldName: "msgLen", header : { text: this.text.msgLen, showTooltip: false }, 
				width: 45, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "decimalLen", fieldName: "decimalLen", header : { text: this.text.decimalLen, showTooltip: false }, 
				width: 45, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			},
			{ 
				name: "fldLvNo", fieldName: "fldLvNo", header : { text: this.text.fldLvNo, showTooltip: false }, 
				width: 45, styles: { textAlignment: 'center', textWrap: 'ellipse' },
				editable: false
			}
		];
		
		if(this.encodingColumnVisible) {
			columns = columns.concat([
				this.gridService.getSelectionEditorColumn({ 
					name: "fldEncoding", fieldName: "fldEncoding", 
					header : { text: this.text.encoding, showTooltip: false, styles: this.data.isEdit ? { background: '#FF6A13', foreground: '#FFF'} : undefined }, 
					width: 80, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: this.data.isEdit ? true : false
				}, this.codes.FIELD_ENCODING, [{value: "", label: ""}]),
				this.gridService.getSelectionEditorColumn({ 
					name: "wideHalfCharCngCd", fieldName: "wideHalfCharCngCd", 
					header : { text: this.text.halfFullWidth, showTooltip: false, styles: this.data.isEdit ? { background: '#FF6A13', foreground: '#FFF'} : undefined }, 
					width: 100, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: this.data.isEdit ? true : false
				}, this.codes.WIDE_HALF_CHAR_CD, [{value: "", label: ""}])
			]);
		}
		
		columns = columns.concat([
			{ 
				name: "fldRmk", fieldName: "fldRmk", header : { text: this.text.fldRmk, showTooltip: false }, 
				width: 180, editable: false, styles: { textWrap: 'ellipse' },
				renderer: {
					showTooltip: true
				}
			},
			{ 
				name: "cdAttrNm", fieldName: "cdAttrNm", header : { text: this.text.cdAttrNm, showTooltip: false }, 
				width: 70, editable: false, styles: { textWrap: 'ellipse' },
				renderer: {
					showTooltip: true
				}
			},
			this.gridService.getSelectionEditorColumn({ 
				name: "indsYn", fieldName: "indsYn", header : { text: this.text.indsYn, showTooltip: false }, 
				width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.YN_CD),
			{ 
				name: "basicVal", fieldName: "basicVal", header : { text: this.text.basicVal, showTooltip: false }, 
				width: 45, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			},	
			this.gridService.getSelectionEditorColumn({ 
				name: "privacyDscd", fieldName: "privacyDscd", header : { text: this.text.privacyDscd, showTooltip: false }, 
				width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.PRIVACY_CD),
			this.gridService.getSelectionEditorColumn({ 
				name: "replKey", fieldName: "replKey", header : { text: this.text.replacedKey, showTooltip: false }, 
				width: 100, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.selectedMsg && this.selectedMsg.chlDscd === 'EXTERNAL' ?  this.codes.REPLACEKEY_EXT : this.codes.REPLACEKEY_INT),
			this.gridService.getSelectionEditorColumn({ 
				name: "encYn", fieldName: "encYn", header : { text: this.text.encYn, showTooltip: false }, 
				width: 70, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.YN_CD),
			this.gridService.getSelectionEditorColumn({ 
				name: "alignNm", fieldName: "alignNm", header : { text: this.text.alignNm, showTooltip: false }, 
				width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.ALIGN_CD, [{value: "NONE", label: " "}]),
			this.gridService.getSelectionEditorColumn({ 
				name: "ioKey", fieldName: "ioKey", header : { text: this.text.ioKey, showTooltip: false }, labelField: 'ioKeyTxt',
				width: 70, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.IO_KEY, [{value: "", label: ""}]),
			this.gridService.getSelectionEditorColumn({ 
				name: "korInclYn", fieldName: "korInclYn", header : { text: this.text.hangleIncludeYn, showTooltip: false }, 
				width: 80, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			}, this.codes.YN_CD),
			{ 
				name: "childDtoNm", fieldName: "childDtoNm", 
				header : { text: this.text.childDtoNm }, 
				width: 138, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false
			},
			{ 
				name: "arraySizeRefVal", fieldName: "arraySizeRefVal", header : { text: this.text.arraySizeRefVal, showTooltip: false }, 
				width: 90, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false 
			}
		]);
		
		columns.push(this.gridService.getSelectionEditorColumn({ 
			name: "fillerVal", fieldName: "fillerVal", header : { text: this.text.fillerVal, showTooltip: false }, 
			width: 40, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false ,
		}, this.codes.FILLER_CD, [{value: "", label: ""}]));
		
		columns.push({ 
			name: "confirmMeta", fieldName: "confirmMeta", header : { text: this.text.confirmMeta, showTooltip: false }, 
			width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' },
			dynamicStyles: [
				{
				criteria: 'value = "' + this.text.accord + '"',
				styles: {foreground: '#1fa67a'}
			},
			{
				criteria: 'value = "' + this.text.discord + '"',
				styles: {foreground: '#ff4526'}
			}],
			editable: false
		});
		
		if(this.data.trxDscd === 'BATCH'){
			columns.push(this.gridService.getSelectionEditorColumn({ 
				name: "formatType", fieldName: "formatType", header : { text: this.text.formatType, showTooltip: false }, 
				width: 60, styles: { textAlignment: 'center', textWrap: 'ellipse' }, editable: false ,
			}, this.codes.FORMAT_TYPE, [{value: "", label: ""}]));
			
			columns.push({ 
				name: "format", fieldName: "format", header : { text: this.text.format, showTooltip: false }, 
				width: 60, styles: { textWrap: 'ellipse' },
				renderer: {
					showTooltip: true
				}
			});
		}
		
		return columns;
	}

	getMsgDetailGridData() {
		if(this.data.gridDataList) {
			this.displayMsgDetailGridData({msglayoutbsDtoList: this.data.gridDataList});
		}else{
			if(this.data.msgLayoutId.length === 0) {
				return;
			}
			
			this.httpService.post(`/msglayoutslist`, this.data.msgLayoutId).then(res => {		
				this.displayMsgDetailGridData(res);
			});
		}
	}
	
	displayMsgDetailGridData(res) {
		let selectedFldUnqId;
		let selectedDetail = res.msglayoutbsDtoList[0];
		
		let gridData = [];
		let calcData = [];
		
		let calcLengthTxt = '';
		
		res.msglayoutbsDtoList.map((data, idx) => {
			this.msglayoutbsDtoMap[data.msgDscd + ':' + data.msgLayoutId] = data;
			
			let fldUnqId = this.utilService.uniqueId('TEMP_LAYOUT_DD_DTO_ID');
			
			gridData.push({
				fldUnqId: fldUnqId,
				msgLayoutId: data.msgLayoutId,
				msgDscd: data.msgDscd,
				rows: data.msglayoutdtDto
			});
			
			calcData = calcData.concat(data.msglayoutdtDto);
			
			if(idx === 0) {
				selectedFldUnqId = fldUnqId;
			}
			
			if(this.data.trxDscd === 'ONLINE' && data.msgDscd === 'IV') {
				selectedFldUnqId = fldUnqId;
				selectedDetail = data;
			}else if(this.data.trxDscd === 'BATCH' && data.msgDscd === 'BATB') {
				selectedFldUnqId = fldUnqId;
				selectedDetail = data;
			}
			
			calcLengthTxt += '<span style="margin-right: 15px !important;">' + this.codeService.getCodeValNm('MSG_TYPE', data.msgDscd) + ' : '+ this.calcLength(data.msglayoutdtDto) + '</span>';
		});

		if(this.data.trxDscd === 'ONLINE') {
			$('.msg-length-wrap').html(this.text.totalLength + ': ' + this.calcLength(calcData));	
		}else{
			$('.msg-length-wrap').html(calcLengthTxt);	
		}
		
		this.selectedMsg = this.utilService.clone(selectedDetail);
		this._selectedMsg = this.utilService.clone(selectedDetail);
		
		this.changeTransactionType();
		this.setApplicationCodeString();
		this.setRegDttm();
		
		
		this.encodingData && this.encodingData.map((data) => {
			data.fieldEncodingDto.map((fieldData) => {
				let rows = gridData;
				let parentLength = rows.length;
				
				for(let j=0; j<parentLength; j++){
					let record = rows[j];
					
					if(record.rows){
						let length = record.rows.length;
						for(let i=0; i<length; i++) {
							let childRecord = record.rows[i];
							
							if(childRecord.fldUnqId == fieldData.fldUnqId) {
								childRecord.fldEncoding = fieldData.fldEncoding;
								fieldData.wideHalfCharCngCd && (childRecord.wideHalfCharCngCd = fieldData.wideHalfCharCngCd);
								return;
							}
						}
					}	
				}
			});
		});
		
		this.detailDataProvider.setJsonRows({rows: gridData}, 'rows', '');
		
		let itemIndex = this.detailGridView.searchItem({fields : ['fldUnqId'], values : [selectedFldUnqId]});
		this.detailGridView.expand(itemIndex);
	}
	
	setApplicationCodeString(){
		const selectedMsg = this.selectedMsg;
		
		if(_.isEmpty(selectedMsg)) return "";
		
		let lvCdsStr = `${selectedMsg.lv1Cd}/${selectedMsg.lv2Cd}/${selectedMsg.lv3Cd}`; 
		if(selectedMsg.lv4Cd) lvCdsStr += `/${selectedMsg.lv4Cd}`;
		selectedMsg.lvCdsStr = lvCdsStr;
	}
	
	setRegDttm(){
		const regDttm = this.selectedMsg.regDttm 
		if(regDttm) {
			const yy = regDttm.substring(0,4);
			const mm = regDttm.substring(4,6);
			const dd = regDttm.substring(6,8);
			const hh = regDttm.substring(8,10);
			const mi = regDttm.substring(10,12);
			const ss = regDttm.substring(12,14);
			this.selectedMsg.regDttmString = yy+"/"+mm+"/"+dd+"  "+hh+":"+mi+":"+ss;
		}
	}
	
	changeTransactionType(){
		if(_.isEmpty(this.selectedMsg)) {
			this.msgTypes = [];
			return;
		}
		
		switch(this.selectedMsg.chlDscd){
			case 'INTERNAL':
				switch(this.selectedMsg.trxDscd){
				case 'ONLINE':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'IV' || v.cdVal == 'CH' || v.cdVal == 'STH' );
					break;
				case 'BATCH':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'BATH' || v.cdVal == 'BATB' || v.cdVal == 'BATT' );
					break;
				}
				break;
			case 'EXTERNAL':
				switch(this.selectedMsg.trxDscd){
				case 'ONLINE':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'IV' || v.cdVal == 'CH' || v.cdVal == 'ISOH' || v.cdVal == 'ISOB');
					break;
				case 'BATCH':
					this.msgTypes = this.allMsgType.filter(v => v.cdVal == 'BATH' || v.cdVal == 'BATB' || v.cdVal == 'BATT' );
					break;
				}
				break;
		}
	}
	
	calcLength(records){
		let gridRows = this.utilService.clone(records);
		
		let msgLen = 0;
		let layoutLength = [];
		let i;
		
		for (i = 0; i < gridRows.length; i++) {
			let row = gridRows[i];
			
			if(row.dataTypeNm == "LAYOUT"){
				var data = {};
				
				data.id = row.fldUnqId;
				
				if(row.arraySizeRefVal == undefined || isNaN(row.arraySizeRefVal)){
					data.msgLen = 1;		
					row.arraySizeRefVal = 1;
				}
				
				if(row.arraySizeRefVal != undefined && row.parentFldNm == undefined){
					data.msgLen = Number(row.arraySizeRefVal);
				}else{
					for (let j = 0; j < layoutLength.length; j++) {
						if(layoutLength[j].id == row.parentFldNm){
							data.msgLen = Number(row.arraySizeRefVal) * Number(layoutLength[j].msgLen);							
						}
					}
				}
				layoutLength.push(data);
				
			}
			
		}
		
		for (i = 0; i < gridRows.length; i++) {
			let row = gridRows[i];
			
			if(row.parentFldNm == undefined){
				msgLen += Number(row.msgLen);
			}else{		
				for (var j = 0; j < layoutLength.length; j++) {
					if(row.parentFldNm == layoutLength[j].id){						
						msgLen += Number(row.msgLen) * Number(layoutLength[j].msgLen);
					}
				}	
			}
		}
		
		return msgLen;
	}
		
	closeModal(isOk){
		if(isOk){
			this.detailGridView.commit();
			
			let resultList = [];
			this.detailDataProvider.getJsonRows(-1, true, 'rows').map((record) => {
				if(record.msgDscd){
					let result = {};
					
					result.msgLayoutId = record.msgLayoutId;
					result.fieldEncodingDto = [];
					record.rows && record.rows.map((childRecord) => {
						(childRecord.fldEncoding || childRecord.wideHalfCharCngCd) && result.fieldEncodingDto.push({
							seq: childRecord.msgSeq,
							fldEngNm: childRecord.fldEngNm,
							fldUnqId: childRecord.fldUnqId,
							fldEncoding: childRecord.fldEncoding,
							wideHalfCharCngCd: childRecord.wideHalfCharCngCd
						});
					});
					
					(result.fieldEncodingDto.length !== 0) && resultList.push(result);
				}
			});
			this.$uibModalInstance.close(resultList);
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.detailGridView.destroy();
		this.detailDataProvider.destroy();
	}
	
	resizeGrid(){
		this.detailGridView && this.detailGridView.resetSize();  
	}
}

module(App.name).controller('SCR0707Controller', SCR0707Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0707/SCR0707.controller.js